import { createRoot } from 'react-dom/client';

if (import.meta.env.DEV) {
  import('/shared/util/whyDidYouRender');
}
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { init as i18nInit } from '/business/shared/translations/i18n';

import { store, persistor } from '/business/shared/state/store';

import App from '/business/shared/App';

import Loading from '/shared/components/Loading';
import ErrorBoundary from '/shared/components/functional/ErrorBoundary';

import config from './config';

const container = document.getElementById('carbon-calculator');
if (!container) {
  throw new Error('No carbon calculator root found');
}
const root = createRoot(container);
i18nInit(config).then(() => {
  root.render(
    <ErrorBoundary>
      <Provider store={store}>
        <PersistGate loading={<Loading />} persistor={persistor}>
          <App config={config} />
        </PersistGate>
      </Provider>
    </ErrorBoundary>,
  );
});
